<div class="head" mat-dialog-title>
  @if (step === steps.Date) {
    <h2 i18n="DateTime picker dialog|title @@dateTimePickerDialog.titleDate">Выберите
    дату</h2>
  }
  @if (step === steps.Time) {
    <h2 i18n="DateTime picker dialog|title @@dateTimePickerDialog.titleTime">Выберите
    время</h2>
  }
  <button class="close-btn" mat-icon-button tabindex="-1" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="content">
  <!--Current selected date time show-->
  @if (data.scheduleAt && step === steps.Date) {
    <div
      tabindex="1"
      style="outline: none; margin-bottom: 8px"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      >
      <span>
        {{ selectedDate.toFormat('EEEE, dd MMMM yyyy')  }}
        <span class="time-big">{{ data.scheduleAt.toFormat('HH:mm') }}</span>
      </span>
      <button mat-icon-button color="warn" matTooltip="Очистить"
        i18n-matTooltip="DateTime picker dialog|tooltip @@dateTimePickerDialog.clearTooltip"
        (click)="clearSelectedDateTime()">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  }

  @if (step === steps.Date && !data.scheduleAt) {
    <div
      fxLayout="row"
      fxLayoutAlign="space-around stretch"
      fxLayoutGap="8px"
      >
      <button aria-label="set today" mat-stroked-button (click)="setToday()" style="width: 50%">
        <mat-icon>today</mat-icon>
        <ng-container i18n="DateTime picker dialog|button @@dateTimePickerDialog.todayButton">сегодня</ng-container>
      </button>
      <button aria-label="set tomorrow" mat-stroked-button (click)="setTomorrow()" style="width: 50%">
        <mat-icon>today</mat-icon>
        <ng-container i18n="DateTime picker dialog|button @@dateTimePickerDialog.yesterdayButton">завтра</ng-container>
      </button>
    </div>
  }

  @if (_scheduleForm.getError('lessNow')) {
    <div style="color: red"
      i18n="DateTime picker dialog|error @@dateTimePickerDialog.pastDateError">Время публикации уходит в прошлое
  </div>
  }

  <div class="calendar-body" [hidden]="step === steps.Time">
    <mat-calendar
      cdkTrapFocus
      #matCalendar="matCalendar"
      (selectedChange)="selectDate($event)"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [selected]="selectedDate"
      [startAt]="selectedDate"
    ></mat-calendar>
  </div>

  @if (step === steps.Time) {
    <div [formGroup]="_scheduleForm" class="calendar-body">
      <div style="padding: 8px 0; margin-bottom: 24px">
        <button mat-stroked-button color="primary" style="width: 100%" (click)="setDateView()">
          <mat-icon>calendar_today</mat-icon>
          {{ selectedDate.toFormat('EEEE, dd MMMM yyyy') }}
        </button>
      </div>
      <mat-form-field style="width: calc(50% - 12px); margin-left: 0px;">
        <mat-select placeholder="Часы"
          i18n-placeholder="DateTime picker dialog|placeholder @@dateTimePickerDialog.hourPlaceholder"
          formControlName="hour">
          @for (h of hours; track h) {
            <mat-option [value]="h">{{ h < 10 ? '0' + h : h }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: calc(50% - 24px); margin-left: 24px;">
        <mat-select placeholder="Минуты"
          i18n-placeholder="DateTime picker dialog|placeholder @@dateTimePickerDialog.minutesPlaceholder"
          formControlName="minutes">
          @for (h of minutes; track h) {
            <mat-option [value]="h">{{ h < 10 ? '0' + h : h }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div>
        <mat-chip-listbox>
          @for (time of cachedTimes; track time) {
            <mat-chip-option (click)="setTime(time)" [removable]="true"
              (removed)="delCached(time)">
              {{ padStart(time) }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
      <br />
    </div>
  }
  <div style="text-align: center" i18n="DateTime picker dialog|text @@dateTimePickerDialog.currentTimezone">
    Часовой пояс: {{ minDate | dateTime: 'z' }}</div>
</mat-dialog-content>
@if (step === steps.Time) {
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close i18n="DateTime picker dialog|button @@dateTimePickerDialog.cancelButton">
    Отмена
  </button>
    <button
      aria-label="save datetime"
      mat-raised-button
      color="primary"
      [disabled]="_scheduleForm.invalid"
      (click)="saveResult()"
      i18n="DateTime picker dialog|button @@dateTimePickerDialog.saveButton"
      >
    Сохранить
  </button>
  </mat-dialog-actions>
}
